import { Component } from 'react'

const CHUNK_RELOAD_KEY = 'blazin:chunk-reload-at'
const CHUNK_ERROR_PATTERN = /chunkloaderror|failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading chunk/i

function isStaleChunkError(error) {
  return CHUNK_ERROR_PATTERN.test(`${error?.name || ''} ${error?.message || ''}`)
}

export class RouteErrorBoundary extends Component {
  state = { error: null, recovering: false }

  static getDerivedStateFromError(error) {
    return { error, recovering: isStaleChunkError(error) }
  }

  componentDidCatch(error, info) {
    console.error('Unable to load this page.', error, info)
    if (!isStaleChunkError(error)) return

    const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
    if (Date.now() - lastReloadAt < 60_000) {
      this.setState({ recovering: false })
      return
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
    const refreshUrl = new URL(window.location.href)
    refreshUrl.searchParams.set('_app_refresh', String(Date.now()))

    Promise.all([
      'caches' in window
        ? caches.keys().then((keys) => Promise.all(keys.filter((key) => key.startsWith('blazin-app-')).map((key) => caches.delete(key))))
        : Promise.resolve(),
      navigator.serviceWorker?.getRegistration().then((registration) => registration?.update()),
    ]).finally(() => window.location.replace(refreshUrl))
  }

  render() {
    if (!this.state.error) return this.props.children
    if (this.state.recovering) return <div className="route-loader" role="status">Updating secure workspace...</div>

    return (
      <section className="route-error" role="alert">
        <div>
          <p className="eyebrow">Page loading error</p>
          <h1>We couldn't open the secure workspace.</h1>
          <p>Please reload to fetch the latest application files.</p>
          <button className="button" type="button" onClick={() => window.location.reload()}>Reload page</button>
        </div>
      </section>
    )
  }
}
